import { render, staticRenderFns } from "./ManageRoomBooking.vue?vue&type=template&id=5ef1acce"
import script from "./ManageRoomBooking.vue?vue&type=script&lang=js"
export * from "./ManageRoomBooking.vue?vue&type=script&lang=js"
import style0 from "./ManageRoomBooking.vue?vue&type=style&index=0&id=5ef1acce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports